import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { VIDEO_CALL_EVENT_TYPE } from '../../../video-conference/models/video-call-event';
import { VideoCallsActions } from '../../../video-conference/store/actions/videoCall';
import { UISocketDataMessage } from '../../models/UISocket';
import { VideoCallEventBase } from '../../models/VideoCallEventBase';
import { AppState } from '../../store/app-state';
import { SocketAction, SocketActionHandler } from '../SocketActionHandler';

export interface UISocketHungUpVideoCallEventMessage extends UISocketDataMessage, VideoCallEventBase {}

@Injectable()
export class VideoCallHungUpHandler implements SocketActionHandler {
    readonly action: SocketAction = VIDEO_CALL_EVENT_TYPE.HUNG_UP;

    constructor(private store: Store<AppState>) {}

    handle(event: UISocketHungUpVideoCallEventMessage): void {
        this.store.dispatch(VideoCallsActions.videoCallStopped({ siteId: event.siteId }));
    }
}
